

document.addEventListener('DOMContentLoaded', function () {

   
      let similarProducts = document.querySelectorAll(".itg_similar_items_desktop .similar_items_products_wrapper #recommended_products .product-item");

      if (similarProducts.length <= 0 ) {
        // document.querySelector(".itg_main_prod_wrapper .itg_similar_items_desktop .similar_items_products_wrapper").classList.add("hide_similar_items");
        // document.querySelector(".itg_main_prod_wrapper .product_content_and_recommadations_wrapper")?.classList.add("hide_similar_items");
        document.querySelector(".portal-account .itg_main_prod_wrapper")?.classList.remove("active");
      }else{
        document.querySelector(".itg_main_prod_wrapper .itg_similar_items_desktop .similar_items_products_wrapper").classList.remove("hide_similar_items");
        document.querySelector(".itg_main_prod_wrapper .product_content_and_recommadations_wrapper")?.classList.remove("hide_similar_items");
        document.querySelector(".portal-account .itg_main_prod_wrapper")?.classList.add("active");
        
      }


  //  var tg_div = document.createElement("div");tg_div.innerHTML = tg_script_bottom_right;document.body.appendChild(tg_div);tg_load_animations("67c8a4d534bc8d4483c44c31", "bottom_right");tgCheckSealRight();

   const secureContainer = document.querySelector('.secure_transaction_container');
    const cartRecapTarget = document.querySelector('.cart-recap__secure-payment');
  
    if (secureContainer && cartRecapTarget) {
      console.log("inside if") ;
      const secureHTML = secureContainer.innerHTML;
  
      // Create a wrapper div
      const wrapper = document.createElement('div');
      wrapper.innerHTML = secureHTML;
  
      // Prepend to target
      cartRecapTarget.prepend(wrapper);
    }

 
  //  var tg_div = document.createElement("div");tg_div.innerHTML = tg_script_bottom_right;document.body.appendChild(tg_div);tg_load_animations("67c8a4d534bc8d4483c44c31", "bottom_right");tgCheckSealRight();
  

  const hotspot_all_products = document.querySelector('.hotspot_product_inner_container .hotspots_all_products');
  
  if (!hotspot_all_products) {
    // console.log("Element not found");
  } else if (hotspot_all_products.children.length === 0) {
    // console.log("zero length");
    hotspot_all_products.closest(".hotspot_product_wrapper").style.display = "none";
  }

  

  // product page similar items slider

  let swiper = new Swiper(".product_list_swiper", {
    slidesPerView: 4,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar"
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      990: {
        slidesPerView: 4,
        spaceBetween: 15
      },
      749: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 15
      }
    }
  });

  // frequently-bought-together product to cart js

  document.querySelector('.frequently-bought-together a.button_link')?.addEventListener('click', function (e) {
    e.preventDefault();

    const selectedItems = [];
    const newTagsArray = [];

    fetch('/cart')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const lineItems = doc.querySelectorAll('tr.line-item');

        lineItems.forEach(item => {
          const prodTag = item.querySelector('.line-item__product-info-wrapper')?.getAttribute('prod-tag');
          if (prodTag) {
            newTagsArray.push(prodTag);
          }
        });

        document.querySelectorAll('.product-info__block-item--itg-frequently-together .frequently-bought-together .error-msg').forEach(el => el.remove());

        document.querySelectorAll('.frequently-bought-together .fbt-checkbox').forEach(checkbox => {
          let checkedProductTag = checkbox.parentElement.querySelector('.single_prod').getAttribute("prod-tag");
          let showConflictMsg = false;
          let errorMessage = "";

          let hasWarehouse = newTagsArray.includes("warehouse_inventory");
          let hasStore = newTagsArray.includes("store inventory");

          let isNewWarehouse = checkedProductTag === "warehouse_inventory";
          let isNewStore = checkedProductTag === "store inventory";

          if (hasWarehouse && isNewStore) {
            showConflictMsg = true;
            errorMessage = "This is a store product and cannot be added to your cart as you have a 'Warehouse Product' added to your cart.Kindly checkout with the Warehouse products first, then come back again to place a separate order for 'Store Products'.";
          } else if (hasStore && isNewWarehouse) {
            showConflictMsg = true;
            errorMessage = "This is a warehouse product and cannot be added to your cart as you have a 'Store Product' added to your cart.Kindly checkout with the Store products first, then come back again to place a separate order for 'Warehouse Products'.";
          }

          document.querySelectorAll('.product-info__block-item--itg-frequently-together .frequently-bought-together .error-msg').forEach(el => el.remove());

          if (checkbox.checked && !showConflictMsg) {
            selectedItems.push({
              id: parseInt(checkbox.dataset.variantId),
              quantity: 1
            });
          } else if (checkbox.checked && showConflictMsg) {
            const errorEl = document.createElement("div");
            errorEl.className = "error-msg";
            errorEl.style.color = "red";
            errorEl.textContent = errorMessage;
            checkbox.closest(".product-info__block-item--itg-frequently-together .frequently-bought-together")?.appendChild(errorEl);
          }
        });

        if (selectedItems.length === 0) {
          return;
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: selectedItems })
        });

      })
      .then(response => {
        if (response && !response.ok) {
          return response.json().then(err => { throw err; });
        }
        if (response) {
          return response.json();
        }
      })
      .then(data => {
        if (data) {
        if(window.theme.cartType == 'drawer'){
          fetch(`${window.routes.cartUrl}?section_id=mini-cart`).then(d=>d.text()).then(text=>{
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
            const miniHtml = sectionInnerHTML.querySelector('#mini-cart').innerHTML;
            document.querySelector('#mini-cart').innerHTML = miniHtml;
            document.querySelector('[data-action="toggle-mini-cart"]').click();
            document.querySelector('#mini-cart').setAttribute('aria-hidden',false);
          });
          }else{
            window.location.href = '/cart';
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert("Failed to add items to cart. Please try again.");
      });
  });


  // frequently-bought-together product to cart js


  // product page media gallery js

  document.querySelectorAll('.product-gallery__thumbnail-list .product-gallery__thumbnail').forEach(thumbnail => {
    thumbnail.addEventListener('click', function () {
      const mediaId = this.getAttribute('data-media-id');

      document.querySelectorAll('.product-gallery__thumbnail').forEach(thumb => {
        thumb.classList.remove('active');
      });


      this.classList.add('active');

      document.querySelectorAll('.product-gallery__carousel-item').forEach(item => {
        item.classList.remove('active');
      });

      const matchedItem = document.querySelector(`.product-gallery__carousel-item[data-media-id="${mediaId}"]`);
      if (matchedItem) {
        matchedItem.classList.add('active');
      }
    });
  });

  // product page media gallery js

  // product page modal js

  function createModal({ modalId, contentId }) {
    // Remove existing modal if present
    const existingModal = document.getElementById(modalId);
    if (existingModal) {
      existingModal.remove();
    }

    // Get the hidden content
    const contentElement = document.getElementById(contentId);
    const modalContent = contentElement ? contentElement.innerHTML : '';

    // Create the modal structure
    const modal = document.createElement('div');
    modal.id = modalId;
    modal.className = 'modal_pdp fade-in_';
    modal.innerHTML = `
          <div class="modal-content_pdp">
            <span class="close_pdp">&times;</span>
            <div class="modal-body_pdp">${modalContent}</div>
          </div>
        `;

    // Append modal to body
    document.body.appendChild(modal);

    // Trigger fade-in
    setTimeout(() => {
      modal.classList.add('visible_pdp');
    }, 10);

    // Close modal on close button click
    const closeButton = modal.querySelector('.close_pdp');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        modal.classList.remove('visible_pdp');
        modal.classList.add('fade-out_pdp');

        setTimeout(() => {
          modal.remove();
        }, 300); // Match animation duration
      });
    }
  }

  // Event binding helper
  function bindModalTrigger(selector, modalId, contentId) {
    const element = document.querySelector(selector);
    if (element) {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        createModal({ modalId, contentId });
      });
    }
  }

  bindModalTrigger('.shipping_popup_on_cart', 'shippingPolicyModalPdp', 'shippingPolicyContentPdpOnCart');
  bindModalTrigger('.itg_main_prod_wrapper .list_icon_content a', 'shippingPolicyModalPdp', 'shippingPolicyContentPdp');
  bindModalTrigger('.single_multicol.fast-delivery', 'shippingPolicyModalPdp', 'shippingPolicyContentPdp');
  bindModalTrigger('.single_multicol.great-service', 'aboutUsContentModalPdp', 'aboutUsContentPdp');
  bindModalTrigger('.single_multicol.top-quality-store', 'googleContentModal', 'googleContentPdp');
  bindModalTrigger('.frieght_only_btn', 'frieghtContentModal', 'frieght_only_content');

  // product page modal js

  // order limit js

  
  const input = document.querySelector('.cart-attribute__field input');
  const orderLimitValue = input ? input.value : null;
  
  if (orderLimitValue) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'OrderLimit': orderLimitValue
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart attribute OrderLimit set:', data);
    })
    .catch(error => {
      console.error('Error setting OrderLimit:', error);
    });
  }
  
  // order limit js

  // login and register inputs js
  
  const inputs = document.querySelectorAll(".form--main .form__input-wrapper .form__field");
  
  inputs.forEach((input) => {
    const checkValue = () => {
      if (input.value.trim() !== "") {
        input.classList.add("filled");
      } else {
        input.classList.remove("filled");
      }
    };
    
    // Initial check
    checkValue();
    
    // On input
    input.addEventListener("input", checkValue);
  });

  // login and register inputs js



  
});

// Repeatedly check for the element every 300ms
// const intervalId = setInterval(() => {
//   const productList = document.querySelector('.boost-sd__filter-product-list');
//   const description = document.querySelector('.boost-sd__header-description');
//   const target = document.querySelector('.boost-sd__pagination-load-more-container-item');

//   if (productList && description && target) {
//     target.appendChild(description);
//     clearInterval(intervalId); // Stop checking once it's done
//   }
// }, 300); // Check every 300 milliseconds

const intervalId = setInterval(() => {    
  const productList = document.querySelector('.boost-sd__filter-product-list');
  const description = document.querySelector('.boost-sd__header-description');
  const parentElement = document.querySelector('.boost-product-listing-column'); // Fixed selector
  const afterEletarget = document.querySelector('.boost-sd__pagination-load-more-container-item');

  if (productList && description && parentElement && afterEletarget) {
    const nextSibling = afterEletarget.nextSibling;
    nextSibling ? parentElement.insertBefore(description, nextSibling) : parentElement.appendChild(description);
    clearInterval(intervalId);
  }
}, 300);




  
  // code by (R) start
    document.addEventListener('click', e => {
      if (e.target.matches('button[aria-label="Close Cart"]'))
        document.body.classList.remove('modal-open-cart');
    });
  // code by (R) end



document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname === '/pages/customer-reviews') {
        let review_btn = document.querySelector(".jdgm-write-rev-link");

        if (review_btn) {
            review_btn.style.pointerEvents = 'none';

            setTimeout(() => {
                review_btn.style.pointerEvents = 'auto';
            }, 2000);
        }
    }
});

// this code for Product page "Similar item sidebar updation (start)"
document.addEventListener('DOMContentLoaded', function() {

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if(!mutation) return;
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains('boost-sd__recommendation')) {
          node.classList.add('itg_collection_grid');
          const id = node.id;
          const titleElement = node.querySelector('.boost-sd__recommendation-title');
          if (id && titleElement) {
            const matchPart = document.querySelector(`.itg_collection_append_part[data-app-id="${id}"]`);          
            if (matchPart && !matchPart.classList.contains('appended')) {
              titleElement.after(matchPart);
              matchPart.classList.add('appended');
            }
          }else {
            setTimeout(()=>observer,1000);
            // console.log("not found");
          }
        }
      });
    });
  });

  // Start observing the whole body
    observer.observe(document.body, { childList: true, subtree: true });
});
// this code for Product page "Similar item sidebar updation (end)"



document.addEventListener('click', e => {
  const r = e.target.closest('.sa-rotating-slider-review');
  if (!r) return;
  const c = r.querySelector('.clamped');
  const b = r.querySelector('.sa-read-more');
  if (!c || !b) return;
  c.classList.toggle('active');
  // b && (b.style.display = c.classList.contains('active') ? 'none' : 'block');
  b && (b.textContent = c.classList.contains('active') ? 'Less' : 'More');
});




// ============================================================
// Bundle PDP — Dynamic Quantity & Price Calculation
// Template: product.bundling-pdp
//
// Strategy overview
// -----------------
// The existing "frequently-bought-together" add-to-cart handler
// (lines 83–181) fires on `.frequently-bought-together a.button_link`.
// On the bundling-pdp template the button also carries `bundle-pdp-btn`.
// A CAPTURE-phase listener attached to the container intercepts the
// click event before it can propagate down to the button and trigger
// the original handler — so there is no double-submit and lines 83–181
// are left completely untouched.
// ============================================================
document.addEventListener('DOMContentLoaded', function () {

  var bundleContainer = document.querySelector('.frequently-bought-together[data-bundle-pdp]');
  if (!bundleContainer) return; // Not the bundling-pdp template — exit immediately

  // ── DOM refs ──────────────────────────────────────────────
  var productRows      = bundleContainer.querySelectorAll('.bundle-pdp-row');
  var totalPriceEl     = bundleContainer.querySelector('.bundle-total-price');
  var mainQtyDisplay   = bundleContainer.querySelector('.bundle-main-qty-display');
  var mainQtyMinus     = bundleContainer.querySelector('.bundle-main-qty-minus');
  var mainQtyPlus      = bundleContainer.querySelector('.bundle-main-qty-plus');

  // ── Helpers ───────────────────────────────────────────────

  /** Format cents (integer) as a USD money string, e.g. 2099 → "$20.99" */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * Read qty from an element.
   * Handles both <input> (uses .value) and display <span> (uses .textContent)
   * so the same logic works if the HTML ever switches between the two.
   */
  function readQty(el) {
    return parseInt(el.tagName === 'INPUT' ? el.value : el.textContent, 10) || 1;
  }

  /**
   * Write qty to an element.
   * Mirrors readQty — handles both <input> and display <span>.
   */
  function writeQty(el, val) {
    if (el.tagName === 'INPUT') { el.value = val; } else { el.textContent = val; }
  }

  /** Return the current main bundle quantity multiplier */
  function getMainQty() {
    return readQty(mainQtyDisplay);
  }

  // ── Recalculation engine ──────────────────────────────────
  /**
   * Iterates every checked bundle product row and computes:
   *   line_total = unit_price_cents × base_qty × main_qty
   * Updates each row's displayed line price and the running bundle total.
   */
  function recalculateBundleTotal() {
    var total = 0;
    var mainQty = getMainQty();

    productRows.forEach(function (row) {
      var checkbox = row.querySelector('.fbt-checkbox');
      if (!checkbox) return;

      var pricePerUnit = parseInt(row.dataset.price, 10) || 0;
      var qtyDisplay   = row.querySelector('.bundle-base-qty-display');
      var baseQty      = qtyDisplay ? readQty(qtyDisplay) : 1;
      var lineTotal    = pricePerUnit * baseQty * mainQty;

      // Update this row's displayed line price
      var linePriceEl = row.querySelector('.bundle-line-price');
      if (linePriceEl) {
        linePriceEl.textContent = checkbox.checked ? formatMoney(lineTotal) : formatMoney(0);
      }

      if (checkbox.checked) {
        total += lineTotal;
      }
    });

    // Update the bundle total display
    if (totalPriceEl) {
      totalPriceEl.textContent = formatMoney(total);
    }
  }

  // ── Main bundle qty: [-] / [+] ────────────────────────────
  mainQtyMinus && mainQtyMinus.addEventListener('click', function () {
    var qty = getMainQty();
    if (qty > 1) {
      writeQty(mainQtyDisplay, qty - 1);
      recalculateBundleTotal();
    }
  });

  mainQtyPlus && mainQtyPlus.addEventListener('click', function () {
    writeQty(mainQtyDisplay, getMainQty() + 1);
    recalculateBundleTotal();
  });

  // ── Per-product base qty & checkbox listeners ─────────────
  productRows.forEach(function (row) {
    var minusBtn    = row.querySelector('.bundle-qty-minus');
    var plusBtn     = row.querySelector('.bundle-qty-plus');
    var qtyDisplay  = row.querySelector('.bundle-base-qty-display');
    var checkbox    = row.querySelector('.fbt-checkbox');

    // Base qty decrease
    minusBtn && minusBtn.addEventListener('click', function (e) {
      e.stopPropagation(); // prevent accidental label/checkbox toggle
      var qty = readQty(qtyDisplay);
      if (qty > 1) {
        writeQty(qtyDisplay, qty - 1);
        recalculateBundleTotal();
      }
    });

    // Base qty increase
    plusBtn && plusBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      writeQty(qtyDisplay, readQty(qtyDisplay) + 1);
      recalculateBundleTotal();
    });

    // Checkbox toggle
    checkbox && checkbox.addEventListener('change', function () {
      recalculateBundleTotal();
    });
  });

  // ── Add Selected to Cart (bundling-pdp handler) ───────────
  /**
   * Intercept clicks on the container in CAPTURE phase.
   * This fires BEFORE the bubble-phase handler on `a.button_link`
   * that was registered in lines 83–181, preventing double-execution.
   */
  bundleContainer.addEventListener('click', function (e) {
    // Only intercept clicks that land on (or inside) .bundle-pdp-btn
    if (!e.target.closest('.bundle-pdp-btn')) return;

    // Stop the event from propagating down to the button's own listeners
    e.stopImmediatePropagation();
    e.preventDefault();

    var mainQty = getMainQty();
    var selectedItems = [];
    var newTagsArray  = [];

    // Step 1: fetch current cart to detect warehouse/store inventory conflicts
    fetch('/cart')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        doc.querySelectorAll('tr.line-item').forEach(function (item) {
          var prodTag = item.querySelector('.line-item__product-info-wrapper')
                            && item.querySelector('.line-item__product-info-wrapper').getAttribute('prod-tag');
          if (prodTag) newTagsArray.push(prodTag);
        });

        // Clear any previous error messages
        bundleContainer.querySelectorAll('.error-msg').forEach(function (el) { el.remove(); });

        // Step 2: collect checked items, applying calculated quantities
        productRows.forEach(function (row) {
          var checkbox   = row.querySelector('.fbt-checkbox');
          if (!checkbox || !checkbox.checked) return;

          var variantId  = parseInt(checkbox.dataset.variantId, 10);
          var qtyDisplay = row.querySelector('.bundle-base-qty-display');
          // var baseQty    = parseInt(qtyDisplay ? qtyDisplay.textContent : 1, 10) || 1;
          var baseQty = qtyDisplay ? readQty(qtyDisplay) : 1;
          var calcQty    = baseQty * mainQty;  // final quantity = base_qty × main_bundle_qty

          // Inventory conflict check (same logic as lines 83–181)
          var prodTag       = row.querySelector('.single_prod') && row.querySelector('.single_prod').getAttribute('prod-tag');
          var hasWarehouse  = newTagsArray.includes('warehouse_inventory');
          var hasStore      = newTagsArray.includes('store inventory');
          var isNewWarehouse = prodTag === 'warehouse_inventory';
          var isNewStore     = prodTag === 'store inventory';

          var conflictMsg = '';
          if (hasWarehouse && isNewStore) {
            conflictMsg = "This is a store product and cannot be added to your cart as you have a 'Warehouse Product' added to your cart. Kindly checkout with the Warehouse products first, then place a separate order for Store Products.";
          } else if (hasStore && isNewWarehouse) {
            conflictMsg = "This is a warehouse product and cannot be added to your cart as you have a 'Store Product' added to your cart. Kindly checkout with the Store products first, then place a separate order for Warehouse Products.";
          }

          if (conflictMsg) {
            var errorEl = document.createElement('div');
            errorEl.className = 'error-msg';
            errorEl.style.color = 'red';
            errorEl.textContent = conflictMsg;
            bundleContainer.appendChild(errorEl);
            return; // skip this item
          }

          selectedItems.push({ id: variantId, quantity: calcQty });
        });

        if (selectedItems.length === 0) return; // nothing to add

        // Step 3: POST to /cart/add.js — main product is NEVER included
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: selectedItems })
        });
      })
      .then(function (response) {
        if (!response) return; // empty cart case or conflict-only case
        if (!response.ok) {
          return response.json().then(function (err) { throw err; });
        }
        return response.json();
      })
      .then(function (data) {
        if (!data) return;

        // Step 4: open cart drawer — reuse exact same mechanism as lines 83–181
        if (window.theme && window.theme.cartType === 'drawer') {
          fetch(window.routes.cartUrl + '?section_id=mini-cart')
            .then(function (d) { return d.text(); })
            .then(function (text) {
              var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
              var miniHtml = sectionInnerHTML.querySelector('#mini-cart').innerHTML;
              document.querySelector('#mini-cart').innerHTML = miniHtml;
              document.querySelector('[data-action="toggle-mini-cart"]').click();
              document.querySelector('#mini-cart').setAttribute('aria-hidden', false);
            });
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (error) {
        console.error('Bundle PDP — cart error:', error);
        alert('Failed to add bundle items to cart. Please try again.');
      });

  }, true); // ← true = capture phase (fires before bubble-phase handlers on child elements)

  // ── Initialise on page load ───────────────────────────────
  // Populate the bundle total price immediately so the user sees it without
  // needing to interact first.
  recalculateBundleTotal();

});
// ============================================================
// END: Bundle PDP — Dynamic Quantity & Price Calculation
// ============================================================
